import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn';
import { organizationInitials } from '../lib/initials';
/**
 * The squared initials chip the design puts beside an organization — 30px, 9px radius, brand
 * tint. Distinct from `Avatar`, which is round and stands for a person; this stands for an
 * organization, and the design draws the two differently on purpose.
 */
export function InitialsChip({ name, size = 'sm', className, }) {
    return (_jsx("span", { "aria-hidden": true, className: cn('inline-flex shrink-0 items-center justify-center rounded-[9px] bg-brand-50 font-bold text-brand-600', size === 'sm' ? 'h-[30px] w-[30px] text-[11px]' : '', size === 'md' ? 'h-[38px] w-[38px] text-[13px]' : '', size === 'lg' ? 'h-14 w-14 rounded-[14px] text-[17px]' : '', className), children: initialsOf(name) }));
}
/**
 * Up to two initials — the design shows two, never three — by the one rule every organization's
 * initials follow (`ORG-031`): see `organizationInitials`.
 */
export function initialsOf(name) {
    return organizationInitials(name);
}
//# sourceMappingURL=initials-chip.js.map